export enum ActionTypes {
  NAVIGATED_INSIDE_THE_APP = 'NAVIGATED_INSIDE_THE_APP',
  POOL_URL_LOADED = 'POOL_URL_LOADED',
  ELEMENT_ID_IN_VIEWPORT_UPDATED = 'ELEMENT_ID_IN_VIEWPORT_UPDATED'
}

type NavigatedInsideApp = {
  type: ActionTypes.NAVIGATED_INSIDE_THE_APP;
  payload: {
    prevUrl: string;
    currentUrl: string;
  };
};

type PoolUrlLoaded = {
  type: ActionTypes.POOL_URL_LOADED;
  payload: {
    [poolQuestions: string]: any;
  };
};

type elementIdInViewPortUpdated = {
  type: ActionTypes.ELEMENT_ID_IN_VIEWPORT_UPDATED;
  payload: {
    elementIdInViewport: string;
  };
};

export type NavigationActionTypes = NavigatedInsideApp | elementIdInViewPortUpdated | PoolUrlLoaded;
